<style>
  th:first-child,
  td:first-child{
    padding-left: 1.4em
  }
</style>

<template>
  <div class="animated fadeIn">
    <div class="row">
      <template v-for="(summary, index) in dashboardSummaries">
        <div class="col-sm-6 col-lg-3" v-if="summary.visible" :key="index">
          <div class="card no-body bg-light" style="min-height: 180px">
            <div class="card-body pb-0">
              <p style="padding-bottom: 0.5em">{{ summary.title }}</p>
              <h4 class="mb-0">{{ summary.count }}</h4>
              <hr v-if="summary.amount !== null">
              <p v-if="summary.amount !== null">
                <span>TOTAL :&emsp;</span>
                <span style="font-size: 1.8em">
                  {{ summary.amount !== undefined ? parseInt(summary.amount).toLocaleString() : summary.amount}}
                </span>
              </p>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="card">
      <div class="card-header"> Finlink Customers </div>

      <Loader :size="90" v-if="fetchingUsers" />

      <table v-if="!fetchingUsers" class="table table-stripped" style="border-top: none !important">
        <thead>
          <tr>
            <th>Name</th>
            <!-- <th class="text-center">Joined</th> -->
            <th class="text-center">Email</th>
            <th class="text-center">Phone Number</th>
            <!-- <th class="text-center">Balance</th> -->
            <!-- <th class="text-center">No. of Accounts</th> -->
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user._id">
            <td>{{ user.displayName }}</td>
            <!-- <td class="text-center"> {{ user.joined }} </td> -->
            <td class="text-center"> {{ user.email }} </td>
            <td class="text-center"> {{ user.phoneNumber }} </td>
            <!-- <td class="text-center"> {{ user.balance.toLocaleString() }} </td> -->
            <!-- <td class="text-center"> {{ user.noOfAccounts }} </td> -->
            <td class="text-center">
              <router-link :to="`users/${user._id}`" class="btn btn-default">
                <i class="fa fa-eye"></i> &nbsp;<span>View</span>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'customers',
    mounted(){
      this.getSummaries();
      this.$store.dispatch('getUsers');

      this.$store.subscribe((mutation) => {
        if(mutation.type === 'SET_USERS'){
          this.fetchingUsers = false;
        }
      });
    },
    data() {
      return {
        fetchingUsers: true
      }
    },
    methods: {
      getSummaries(){
        this.$store.dispatch('getSummaries');
      }
    },
    computed: {
      ...mapState(['users', 'dashboardSummaries'])
    }
  }
</script>
